<template>
    <div id="video-avatar">
        <div class="video-container">
            <span id="status"></span>
            <span id="counter"></span>
            <div id="loader" v-if="!streamStarted">
                <div v-if="streamError == ''" class="loading-text">Caricamento in corso...</div>
                <div class="loader-icon" v-if="streamError == ''"><div></div><div></div><div></div><div></div></div>
                <div v-if="streamError != ''" class="loading-error">{{streamError}}</div>
            </div>
            <video id="talk_video" x-webkit-airplay="allow" preload="yes" muted autoplay playsinline loop></video>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

const RTCPeerConnection = (
  window.RTCPeerConnection ||
  window.webkitRTCPeerConnection ||
  window.mozRTCPeerConnection
).bind(window);

export default {
    name: 'videoavatar',
    props: ['didBearer','didAvatarVoiceId','didAvatarVoiceType'],
    data() {
        return {
            result_url: null,
            token: this.didBearer,
            credits: null,
            session_id: null,
            stream_id: null,
            offer: null,
            offerSdp: null,
            iceservers: null,
            peerConnection: null,
            sessionClientAnswer: null,
            textmessages: [],
            requestHeaders: {},
            statsIntervalId: null,
            videoIsPlaying: null,
            lastBytesReceived: null,
            avatar_url: '',
            streamStarted: false,
            streamError: ''
       }
    },
    created(){

    },
    beforeMount(){

    },
    mounted(){
        this.requestHeaders = {
            accept: 'application/json',
            'content-type': 'application/json',
            authorization: 'Basic ' + this.token,
        };

        if(window.location.origin.indexOf('localhost') > -1){
            this.avatar_url = 'https://dev.platform.crowdm.eu/assets/avatar_videoavatar.jpg';
        }else{
            this.avatar_url = window.location.origin + '/assets/avatar_videoavatar.jpg';
        }
        

        //check buffering of idle video
        this.checkVideoState();

        this.getCredits().then(() => {
            console.log('Credits: ' + this.credits.remaining)
            this.createStream().then((resData) => {
                this.createPeerConnection(resData.data).then(()=>{
                    this.startStream().then(() => {    

                        setTimeout(() => {
                            this.streamStarted = true;
                        }, 1000);

                        this.$root.$on('speech-to-text.final', () => {                            
                            let status = document.getElementById('status');
                            status.classList.add('thinking');
                        });                    
                        this.$root.$on('messages-received', async (messages)=>{
                            console.log('Credits: ' + this.credits.remaining);
                            
                            let status = document.getElementById('status');
                            status.classList.add('thinking');

                            messages.forEach(message => {
                                if(message.type == "simpleText") {
                                    let text = this.sanitizeMessage(message.content.text);
                                    this.textmessages.push(text);
                                }
                                if(message.type == "buttons") {
                                    let text = this.sanitizeMessage(message.content.title);
                                    this.textmessages.push(text);
                                }
                                 if(message.type == "single-question") {
                                    let text = this.sanitizeMessage(message.content.title);
                                    this.textmessages.push(text);
                                }
                            });

                            if(this.peerConnection.iceConnectionState == 'disconnected'){
                                console.log('connection ended')
                                this.deleteStream();
                            }
                            // console.log(this.peerConnection.signalingState);
                            // console.log(this.peerConnection.iceConnectionState)
                            if(this.peerConnection.signalingState == 'stable' && this.peerConnection.iceConnectionState == 'connected'){
                                this.talkStream();
                            }
                        });
                    });
                });

            });
        });
    },
    methods: {
        getCredits(){
            return new Promise((resolve,reject)=>{
                const url = 'https://api.d-id.com/credits';

                const options = {
                    method: 'GET',
                    credentials: 'omit',
                    url: url,
                    headers: this.requestHeaders
                };

                const self = this;
                fetch(url, options).then(response => response.json()).then(res=>{
                    self.credits = res;
                    resolve(true);
                }).catch(err => {
                    console.error(err)
                });
            });
        },
        createStream(){
            return new Promise(async (resolve, reject) => {
                const url = 'https://api.d-id.com/talks/streams';
                const avatar = this.avatar_url;
                const options = {
                    method: 'POST',
                    headers: this.requestHeaders,
                    credentials: 'omit',
                    body: JSON.stringify({
                        //face: {top_left: [0, 0], size: 512},
                        config: {motion_factor: 0, align_expand_factor: 0, stitch: true},
                        source_url: avatar,
                    })
                };

                const sessionResponse = await this.fetchWithRetries(url, options).then(response => response.json()).then(response => {                   
                    this.session_id = response.session_id;
                    this.stream_id = response.id;
                    this.offer = response.offer;
                    this.offerSdp = response.offer.sdp;
                    resolve({
                        data: response
                    });
                }).catch(err => {
                    this.streamError = 'Errore durante il caricamento. Riprova più tardi.'
                });
            });
        },
        startStream(){
            return new Promise((resolve,reject) => {
                const url = 'https://api.d-id.com/talks/streams/' + this.stream_id + '/sdp';
                const options = {
                    method: 'POST',
                    url: url,
                    headers: this.requestHeaders,
                    credentials: 'omit',
                    body: JSON.stringify({
                        session_id: this.session_id,
                        answer: this.sessionClientAnswer
                    }),
                };

                const self = this;

                fetch(url, options).then(response => response.json()).then(response => {
                    console.log(response);
                    resolve(true);
                }).catch(err => console.error(err));
            });
        },
        deleteStream(){
            const url = 'https://api.d-id.com/talks/streams/' + this.stream_id;
            const options = {
                method: 'DELETE',
                headers: this.requestHeaders,
                body: JSON.stringify({session_id: this.session_id})
            };
            
            fetch(url, options).then(response => response.json()).then(response => {
                window.location.reload();
            }).catch(err => console.error(err));
        },
        createPeerConnection(data){
            return new Promise(async (resolve)=>{
                this.peerConnection = new RTCPeerConnection({
                    iceServers: data.ice_servers
                });

                this.peerConnection.addEventListener('icegatheringstatechange', this.onIceGatheringStateChange, true);
                this.peerConnection.addEventListener('icecandidate', this.onIceCandidate, true);
                this.peerConnection.addEventListener('iceconnectionstatechange', this.onIceConnectionStateChange, true);
                this.peerConnection.addEventListener('connectionstatechange', this.onConnectionStateChange, true);
                this.peerConnection.addEventListener('signalingstatechange', this.onSignalingStateChange, true);
                this.peerConnection.addEventListener('track', this.onTrack, true);

                let offer = new RTCSessionDescription({
                    type: data.offer.type,
                    sdp: data.offer.sdp,
                });
                
                await this.peerConnection.setRemoteDescription(offer);
                console.log('set remote sdp OK');

                this.sessionClientAnswer = await this.peerConnection.createAnswer();
                console.log('create local sdp OK');

                await this.peerConnection.setLocalDescription(this.sessionClientAnswer);
                console.log('set local sdp OK');

                resolve(true);
            })

        },
        onIceGatheringStateChange() {
            // iceGatheringStatusLabel.innerText = peerConnection.iceGatheringState;
            // iceGatheringStatusLabel.className = 'iceGatheringState-' + peerConnection.iceGatheringState;
            //console.log(this.peerConnection)
        },
        onIceCandidate(event) {
            //console.log('onIceCandidate')
            if (event.candidate) {
                //console.log('onIceCandidate', event);
                const { candidate, sdpMid, sdpMLineIndex } = event.candidate;

                const url = 'https://api.d-id.com/talks/streams/' + this.stream_id + '/ice';
                const options = {
                    method: 'POST',
                    url: url,
                    headers: this.requestHeaders,
                    body: JSON.stringify({candidate, sdpMid, sdpMLineIndex, session_id: this.session_id}),
                    credentials: 'omit',
                };

                const self = this;

                fetch(url, options).then(response => response.json()).then(response => {
                    console.log(response)
                }).catch(err => console.error(err));
            }
        },
        onIceConnectionStateChange() {
            console.log('onIceConnectionStateChange')
            let status = document.getElementById('status');
            if(this.peerConnection.iceConnectionState == 'failed' || this.peerConnection.iceConnectionState == 'disconnected'){
               this.deleteStream();
            }
            if(this.peerConnection.iceConnectionState == 'connected'){
                status.classList.remove('off-line');
                status.classList.add('on-line');
            }            
        },
        onConnectionStateChange() {
             console.log('onConnectionStateChange')
            if(this.peerConnection.iceConnectionState == 'failed' || this.peerConnection.iceConnectionState == 'disconnected'){
                this.deleteStream();
            }
            // not supported in firefox
            // peerStatusLabel.innerText = peerConnection.connectionState;
            // peerStatusLabel.className = 'peerConnectionState-' + peerConnection.connectionState;
        },
        onSignalingStateChange() {
            //console.log(this.peerConnection)
            // signalingStatusLabel.innerText = peerConnection.signalingState;
            // signalingStatusLabel.className = 'signalingState-' + peerConnection.signalingState;
        },
        onVideoStatusChange(videoIsPlaying, stream) {
            console.log('onVideoStatusChange')
            let status = document.getElementById('status');
            if (videoIsPlaying) {
                const remoteStream = stream;
                this.setVideoElement(remoteStream);
                status.classList.remove('thinking');
                this.$root.$emit('avatarvideo_playing', true);                
            } else {
                this.playIdleVideo();
                this.$root.$emit('avatarvideo_playing', false);
            }
        },
        onTrack(event) {
            /**
             * The following code is designed to provide information about wether currently there is data
             * that's being streamed - It does so by periodically looking for changes in total stream data size
             *
             * This information in our case is used in order to show idle video while no talk is streaming.
             * To create this idle video use the POST https://api.d-id.com/talks endpoint with a silent audio file or a text script with only ssml breaks
             * https://docs.aws.amazon.com/polly/latest/dg/supportedtags.html#break-tag
             * for seamless results use `config.fluent: true` and provide the same configuration as the streaming video
             */
            

            if (!event.track) return;

            let statsIntervalId = setInterval(async () => {
                const stats = await this.peerConnection.getStats(event.track);
                stats.forEach((report) => {
                    let type = (typeof report.mediaType !== 'undefined') ? report.mediaType : report.kind;
                    if (report.type === 'inbound-rtp' && type === 'video') {
                        const videoStatusChanged = this.videoIsPlaying !== report.bytesReceived > this.lastBytesReceived;                    
                        if (videoStatusChanged) {
                            this.videoIsPlaying = report.bytesReceived > this.lastBytesReceived;
                            this.onVideoStatusChange(this.videoIsPlaying, event.streams[0]);
                        }
                        this.lastBytesReceived = report.bytesReceived;
                    }
                });
            }, 500);
        },
        talkStream(){          
            
            const url = 'https://api.d-id.com/talks/streams/';
            const avatar = this.avatar_url;
            
            let counter = document.getElementById('counter');
            counter.innerText = this.lengthInUtf8Bytes(this.textmessages.join(' '));

            const options = {
                method: 'POST',
                url: url + this.stream_id,
                headers: this.requestHeaders,
                data: {
                    script: {
                        type: 'text',
                        subtitles: 'false',
                        provider: {
                            type: this.didAvatarVoiceType,
                            voice_id: this.didAvatarVoiceId,
                        },
                        ssml: 'false',
                        input: this.textmessages.join(' ')
                    },
                    config: {fluent: 'false', pad_audio: '0.0'},
                    session_id: this.session_id,
                    name: 'Maia',
                    source_url: avatar
                }
            };

            const self = this;

            axios.request(options).then(function (response) {
                self.textmessages = [];
                //self.session_id = response.data.session_id;
                //console.log('TalkStram Response', response);
            }).catch(function (error) {
                console.error(error);
            }).finally(()=>{
                
            });
        },
        async fetchWithRetries(url, options, retries = 1) {
            try {
                return await fetch(url, options);
            } catch (err) {
                if (retries <= maxRetryCount) {
                    const delay = Math.min(Math.pow(2, retries) / 4 + Math.random(), maxDelaySec) * 1000;

                    await new Promise((resolve) => setTimeout(resolve, delay));

                    console.log(`Request failed, retrying ${retries}/${maxRetryCount}. Error ${err}`);
                    return fetchWithRetries(url, options, retries + 1);
                } else {
                    throw new Error(`Max retries exceeded. error: ${err}`);
                }
            }
        },
        setVideoElement(stream) {
            console.log('setVideoElement')
            let video = document.getElementById('talk_video');
            
            if (!stream) return;
            video.srcObject = stream;
            video.loop = false;
            video.muted = false;

            // safari hotfix
            if (video.paused) {
                video.play().then((_) => {}).catch((e) => {});
            }
        },
        playIdleVideo() {
            console.log('playIdleVideo')
            

            let video = document.getElementById('talk_video');
            video.srcObject = undefined;
            video.src = window.location.origin + '/assets/idle.mp4';
            video.loop = true;

            this.checkVideoState();
        },
        checkVideoState(){
            let video = document.getElementById('talk_video'); 
            let videoInterval  = setInterval(() => {
                if(video.readyState === 4){
                    clearInterval(videoInterval);
                    video.play();
                }
            }, 500);            
        },
        sanitizeMessage(text){
            text = text.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
            return text;
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#x27;',
                "/": '&#x2F;',
            };
            const reg = /[&<>"'/]/ig;
            return text.replace(reg, (match)=>(map[match]));
        },
        lengthInUtf8Bytes(str) {
            // Matches only the 10.. bytes that are non-initial characters in a multi-byte sequence.
            var m = encodeURIComponent(str).match(/%[89ABab]/g);
            return str.length + (m ? m.length : 0);
        }
    }
}
</script>
<style>
.video-container, .img-container{
    position: relative;
    /* overflow: hidden; */
    max-width: 200px;
    margin: auto;
    margin-top: 25px;
    
}
.video-container::before, .img-container::before{
    content: '';
    padding-top: 100%;
    display: block;
    position: relative;
}
.video-container video, .img-container img{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #f0f0f0;
}
#status{
    position: absolute;
    top: 17px;
    right: 17px;
    background: #cecece;
    display: block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    z-index: 1;
}
#status.off-line{
    background-color: red;
}
#status.on-line{
    background-color: green;
}
#counter{
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 12px;
    opacity: 0.2;
}
#loader{
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    background: #ccc;
    z-index: 9999999;
}
#loader .loading-text, #loader .loading-error, #loader .loading-icon{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
}
#loader .loading-text, #loader .loading-error{
    color: #fff;
    text-align: center;
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 1px;
    
}
@media only screen and (max-width: 350px) {
    #loader .loading-text, #loader .loading-error{
        font-size: 22px;        
    }
}
#loader .loader-icon{
    display: inline-block;
    position: absolute;
    width: 80px;
    height: 80px;
    top: calc(50% - 80px);
    left: 50%;
    transform: translate(-50%,-50%);
}
#loader .loader-icon div{
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}
#loader .loader-icon div:nth-child(1) {
    animation-delay: -0.45s;
}
#loader .loader-icon div:nth-child(2) {
    animation-delay: -0.3s;
}
#loader .loader-icon div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
        transform: rotate(0deg);
  }
  100% {
        transform: rotate(360deg);
  }
}
</style>